<template>
	<div :class="fullScreen ? 'fullscreen-map' : ''">
		<MapSearch @flyto="flyTo" :labels="labels" />

		<MapboxMap
			access-token="pk.eyJ1IjoiYmVudG9kYXkiLCJhIjoiY2xlNzh4Y3lhMDM1bzN1bWdrYTFmMWN5bCJ9.fvgJSulDCj8AeuQ-pb8CYg"
			map-style="mapbox://styles/bentoday/cleeburn4005m01kn63ahk5u1"
			:center="center"
			:zoom="4"
			:pitchWithRotate="false"
			:dragRotate="false"
			:language="language"
			@mb-created="(mapInstance) => (mapRef = mapInstance)"
			@mb-drag="deselectMarker"
			@mb-load="mapLoaded"
			@mb-zoom="currentZoom = $event.target.getZoom()"
		>
			<template v-if="fullScreen">
				<h1 class="heading-sm map-title">Milence European<br />Public Charging Network</h1>

				<MapFilters
					@filter="selectedAmenities = $event"
					@selectedMarker="selectedMarker = $event"
					:selectedMarker="selectedMarker"
					:labels="labels"
					:useRoutes="useRoutes"
					:routeDataLoaded="routeDataLoaded"
					:routeData="routeData"
					:fullScreen="fullScreen"
					v-model:activeRoutes="activeRoutes"
				>
					<MapSlideOut
						v-if="selectedMarker"
						:marker="selectedMarker"
						:labels="labels"
						:useRoutes="useRoutes"
						:fullScreen="fullScreen"
						@close="deselectMarker"
						class="map-slideout map-slideout--desktop"
					/>
				</MapFilters>
			</template>

			<template v-else>
				<MapFilters
					@filter="selectedAmenities = $event"
					@selectedMarker="selectedMarker = $event"
					:selectedMarker="selectedMarker"
					:labels="labels"
					:useRoutes="useRoutes"
					:routeDataLoaded="routeDataLoaded"
					:routeData="routeData"
					:fullScreen="fullScreen"
					v-model:activeRoutes="activeRoutes"
				>
					<MapSlideOut
						v-if="selectedMarker"
						:marker="selectedMarker"
						:labels="labels"
						:useRoutes="useRoutes"
						:fullScreen="fullScreen"
						@close="deselectMarker"
						class="map-slideout map-slideout--desktop"
					/>
				</MapFilters>
			</template>

			<MapSlideOut
				v-if="selectedMarker"
				:labels="labels"
				:marker="selectedMarker"
				:useRoutes="useRoutes"
				:fullScreen="fullScreen"
				@close="deselectMarker"
				class="map-slideout map-slideout--mobile"
			/>
			<MapboxMarker
				v-for="location in this.filteredLocations"
				:key="location.id"
				:lng-lat="[location.lng, location.lat]"
			>
				<div
					@click="markerClick"
					:data-id="location.id"
					:class="[isNotSelected(location.id), location.location_status]"
				>
					<svg
						v-if="!location.clickable"
						:class="classObject(location.id)"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect width="24" height="24" rx="5" fill="#BABCBC" />
						<g clip-path="url(#a)" fill="#fff">
							<path d="M7.232 6h9.483l-.91 4H6.32l.911-4ZM5.41 14h9.483l-.91 4H4.5l.91-4Z" />
							<path d="M19.1 10h-3.296l-.91 4h4.741l.586-2.571c.166-.731-.382-1.43-1.121-1.43Z" />
						</g>
						<defs>
							<clipPath id="a">
								<path fill="#fff" d="M4.5 6h15.75v12H4.5z" />
							</clipPath>
						</defs>
					</svg>

					<svg
						v-if="location.location_status == 'planned' && location.clickable"
						:class="classObject(location.id)"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect width="24" height="24" rx="5" fill="grey" />
						<g clip-path="url(#a)" fill="#fff">
							<path d="M7.232 6h9.483l-.91 4H6.32l.911-4ZM5.41 14h9.483l-.91 4H4.5l.91-4Z" />
							<path d="M19.1 10h-3.296l-.91 4h4.741l.586-2.571c.166-.731-.382-1.43-1.121-1.43Z" />
						</g>
						<defs>
							<clipPath id="a">
								<path fill="#fff" d="M4.5 6h15.75v12H4.5z" />
							</clipPath>
						</defs>
					</svg>

					<svg
						v-if="location.location_status == 'in_build' && location.clickable"
						:class="classObject(location.id)"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect width="24" height="24" rx="5" fill="#eb6113" />
						<g clip-path="url(#a)" fill="#fff">
							<path d="M7.232 6h9.483l-.91 4H6.32l.911-4ZM5.41 14h9.483l-.91 4H4.5l.91-4Z" />
							<path d="M19.1 10h-3.296l-.91 4h4.741l.586-2.571c.166-.731-.382-1.43-1.121-1.43Z" />
						</g>
						<defs>
							<clipPath id="a">
								<path fill="#fff" d="M4.5 6h15.75v12H4.5z" />
							</clipPath>
						</defs>
					</svg>

					<svg
						v-if="location.location_status == 'operational' && location.clickable"
						:class="classObject(location.id)"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect width="24" height="24" rx="5" fill="#1D5B3E" />
						<g clip-path="url(#a)" fill="#fff">
							<path d="M7.232 6h9.483l-.91 4H6.32l.911-4ZM5.41 14h9.483l-.91 4H4.5l.91-4Z" />
							<path d="M19.1 10h-3.296l-.91 4h4.741l.586-2.571c.166-.731-.382-1.43-1.121-1.43Z" />
						</g>
						<defs>
							<clipPath id="a">
								<path fill="#fff" d="M4.5 6h15.75v12H4.5z" />
							</clipPath>
						</defs>
					</svg>
				</div>
			</MapboxMarker>
			<MapboxNavigationControl position="top-right" :showCompass="false" />
			<MapboxGeolocateControl />

			<div class="map-legend">
				<ul class="map-legend__ranges">
					<li v-for="range in ranges">
						<span class="icon" :style="`background-color: ${range.color};`"></span>
						<span>{{ range.label }}</span>
					</li>
				</ul>
				<ul class="map-legend__locations">
					<li>
						<svg class="icon icon-marker-green">
							<use xlink:href="#icon-marker-green"></use>
						</svg>
						<span>{{ labels.operational_location }}</span>
					</li>
					<li>
						<svg class="icon icon-marker-orange">
							<use xlink:href="#icon-marker-orange"></use>
						</svg>
						<span>{{ labels.under_construction }}</span>
					</li>
					<li>
						<svg class="icon icon-marker-grey">
							<use xlink:href="#icon-marker-grey"></use>
						</svg>
						<span>{{ labels.planned_location }}</span>
					</li>
				</ul>
			</div>

			<template v-if="routeData">
				<MapboxSource
					v-for="route in routeData"
					:id="route.id"
					:options="{
						type: 'geojson',
						data: route.data,
					}"
				/>

				<template v-for="route in routeData">
					<MapboxLayer
						v-if="activeRoutes.includes(route.id)"
						:key="route.id"
						:id="`layer-route-${route.id}`"
						:options="{
							type: 'line',
							source: route.id,
							layout: {
								'line-join': 'round',
								'line-cap': 'round',
							},
							paint: {
								'line-color': route.color,
								'line-width': 4,
							},
						}"
					/>
				</template>
			</template>
		</MapboxMap>
	</div>
</template>

<script>
import {
	MapboxMap,
	MapboxMarker,
	MapboxNavigationControl,
	MapboxGeolocateControl,
	MapboxLayer,
	MapboxSource,
} from '@studiometa/vue-mapbox-gl';
import MapSlideOut from './MapSlideOut';
import MapFilters from './MapFilters';
import MapFiltersInline from './MapFiltersInline';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapSearch from './MapSearch.vue';
import { routes } from './routes.js';

export default {
	components: {
		MapboxMap,
		MapboxMarker,
		MapboxNavigationControl,
		MapboxGeolocateControl,
		MapSlideOut,
		MapFilters,
		MapSearch,
		MapboxLayer,
		MapboxSource,
		MapFiltersInline,
	},
	props: ['markers', 'labels', 'language', 'useRoutes', 'fullScreen'],
	data() {
		return {
			selectedAmenities: [],
			currentZoom: 4,
			locations: {},
			newLocations: {},
			originalCollection: [],
			selectedMarker: null,
			center: [6.7508222, 51.1686936],
			mapRef: null,
			routeData: [],
			routeDataLoaded: false,
			activeRoutes: [],
			circleIds: [],
			ranges: [
				{
					km: 180,
					label: '0-180 km',
					color: '#A1BD95',
				},
				{
					km: 360,
					label: '180-360 km',
					color: '#C4D9C0',
				},
			],
		};
	},
	watch: {
		selectedMarker(newMarker, oldMarker) {
			if (!newMarker) {
				this.removeCurrentRange();
				return;
			}

			if (oldMarker && newMarker.id !== oldMarker.id) {
				this.removeCurrentRange();
			}

			if (newMarker.hide_range) {
				return;
			}

			this.createRange();
		},
	},
	mounted() {
		this.locations = this.markers;
		this.originalCollection = this.locations;
		this.useRoutes && this.loadRoutes();
	},
	computed: {
		filteredLocations() {
			return Object.fromEntries(
				Object.entries(this.originalCollection).filter(([key, value]) => {
					// Zoom filter
					if (this.currentZoom > 8 && !value.clickable) {
						return false;
					}

					// Amenity filter
					const amenities = value.amenities || [];
					const passesAmenityFilter = this.selectedAmenities.every((f) => amenities.includes(f));

					return this.selectedAmenities.length === 0 || passesAmenityFilter;
				})
			);
		},
	},
	methods: {
		markerClick(event) {
			const selectedId = event.currentTarget.dataset.id;
			const location = this.locations[parseInt(selectedId)];

			if (!location.clickable) {
				return;
			}

			this.selectedMarker = location;
			// this.map.flyTo({center: [this.selectedMarker.lng, this.selectedMarker.lat], zoom: 5});
		},
		classObject(id) {
			return {
				'marker-active': this.selectedMarker && this.selectedMarker.id == id,
			};
		},
		isNotSelected(id) {
			return {
				'marker-inactive': this.selectedMarker && this.selectedMarker.id !== id,
				'marker-not-clickable': !this.locations[id]?.clickable,
			};
		},
		deselectMarker() {
			this.selectedMarker = null;
		},
		flyTo(location) {
			this.mapRef.flyTo({
				center: location,
				zoom: 8,
			});
		},
		async loadRoutes() {
			if (!this.useRoutes) {
				return;
			}

			const routeData = await Promise.all(
				routes.map(async (route) => {
					const resp = await fetch(route.url);
					const json = await resp.json();

					return {
						...route,
						data: json,
					};
				})
			);

			const order = [
				'northsea-rine-mediterranean',
				'north-sea-baltic',
				'scandinavian-mediterranean',
				'rhine-danube',
				'baltic-sea-adriatic-sea',
				'mediterranean',
				'atlantic',
				'western-balkans-eastern-mediterranean',
				'baltic-sea-black-sea-aegean-sea',
			];

			routeData.sort((a, b) => {
				const aIndex = order.indexOf(a.id);
				const bIndex = order.indexOf(b.id);

				return aIndex - bIndex;
			});

			this.routeData = routeData;
			this.routeDataLoaded = true;
		},
		createRange() {
			const coords = [this.selectedMarker.lng, this.selectedMarker.lat];

			this.ranges.forEach(({ km }) => {
				const circleGeoJSON = this.createGeoJSONCircle(coords, km, 64);

				const sourceId = `circle-${this.selectedMarker.id}-${km}`;
				const layerId = `circle-layer-${this.selectedMarker.id}-${km}`;

				this.circleIds.push({
					sourceId,
					layerId,
				});

				this.mapRef.addSource(sourceId, {
					type: 'geojson',
					data: circleGeoJSON,
				});

				this.mapRef.addLayer({
					id: layerId,
					type: 'fill',
					source: sourceId,
					layout: {},
					paint: {
						'fill-color': '#6C9F62',
						'fill-opacity': 0.4,
					},
				});
			});
		},
		removeCurrentRange() {
			this.circleIds.forEach(({ sourceId, layerId }) => {
				if (this.mapRef.getLayer(layerId)) {
					this.mapRef.removeLayer(layerId);
				}

				if (this.mapRef.getSource(sourceId)) {
					this.mapRef.removeSource(sourceId);
				}
			});

			this.circleIds = [];
		},
		createGeoJSONCircle(center, radiusInKm, points) {
			const coords = {
				latitude: center[1],
				longitude: center[0],
			};
			const kmToRadius = radiusInKm / 6371; // Radius of the earth in km

			const ret = [];
			const distanceX = kmToRadius / Math.cos((coords.latitude * Math.PI) / 180);

			for (let i = 0; i < points; i++) {
				const theta = (i / points) * (2 * Math.PI);
				const x = distanceX * Math.cos(theta);
				const y = kmToRadius * Math.sin(theta);

				const newX = coords.longitude + (x * 180) / Math.PI;
				const newY = coords.latitude + (y * 180) / Math.PI;

				ret.push([newX, newY]);
			}

			ret.push(ret[0]); // Complete the circle
			return {
				type: 'FeatureCollection',
				features: [
					{
						type: 'Feature',
						geometry: {
							type: 'Polygon',
							coordinates: [ret],
						},
					},
				],
			};
		},
		mapLoaded() {},
	},
};
</script>
